import type { Strength } from '../types/resume';

export const strengths: Strength[] = [
  {
    title: 'Technology with a commercial lens',
    evidence:
      'Moves easily between IT direction and sales, channel and marketing leadership, connecting technology with commercial objectives.',
  },
  {
    title: 'Results-driven, long-term vision',
    evidence: 'Delivered measurable outcomes, such as doubling the customer base in Peru in one year, while building multi-year transformation roadmaps.',
  },
  {
    title: 'Regional and multicultural reach',
    evidence: 'Led markets and teams across South America, Mexico and the United States, adapting readily to multicultural environments.',
  },
  {
    title: 'Governance and strategic oversight',
    evidence: 'Served as Board Member and then Chairman of the Board at Provectis, guiding long-term strategy and leadership alignment.',
  },
  {
    title: 'Communication and teamwork',
    evidence: 'Customer- and teamwork-oriented, with excellent communication skills built through executive coaching, alliances and regional teams.',
  },
  {
    title: 'Builder of new business',
    evidence: 'Opened new markets, launched country strategies and products, and designed growth plans from the ground up.',
  },
];
